import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Data Foundations & Analytical Essentials",
    description:
      "Foundations of Data Science, Data Science lifecycle, Math foundation (Algebra, Calculus, Stats basics), Python essentials, Real-world data applications.",
  },
  {
    title: "Python Programming for Data Intelligence",
    description:
      "Python for Data Science, NumPy for numerical computing, Pandas for data manipulation, Matplotlib & Seaborn for visualization, Working with Jupyter Notebook, Exploratory Data Analysis (EDA).",
  },
  {
    title: "Statistical Thinking & Probability Concepts",
    description:
      "Statistics & Probability, Descriptive statistics, Inferential statistics, Hypothesis testing, Probability distributions, Correlation & covariance.",
  },
  {
    title: "Data Preprocessing & Feature Engineering",
    description:
      "Data Wrangling & Preprocessing, Missing value handling, Encoding categorical data, Scaling & normalization, Outlier detection, Feature creation & selection.",
  },
  {
    title: "Machine Learning with Predictive Modeling",
    description:
      "Machine Learning - Superviseds, Linear & logistic regression, Decision trees & random forests, Support Vector Machines, KNN, Naive Bayes, Model performance metrics.",
  },
  {
    title: "Unsupervised Intelligence & Pattern Discovery",
    description:
      "Machine Learning - Unsupervise, Clustering (K-Means, Hierarchical), PCA & dimensionality reduction, Anomaly detection, Pattern extraction techniques.",
  },
  {
    title: "Deep Learning & Neural Network Systems",
    description:
      "Deep Learning & Neural Network, ANN fundamentals, Activation & loss functions, TensorFlow & Keras basics, Building simple neural networks, Training & evaluation.",
  },
  {
    title: "Data Visualization & Business Insights Tools",
    description:
      "Visualization & BI Tools, Tableau dashboards, Power BI reports, Advanced charts & stories, Business problem analysis, Decision-making with insights.",
  },
  {
    title: "SQL Mastery & Database Operations",
    description:
      "SQL & Databases, SQL basics (SELECT, JOIN, WHERE), CTEs & window functions, Database design concepts, Query optimization, MySQL / PostgreSQL hands-on.",
  },
  {
    title: "Big Data Ecosystem & Cloud Fundamentals",
    description:
      "Big Data & Cloud, Hadoop & Spark introduction, Cloud platforms (AWS, GCP, Azure), Data pipelines overview, Real-time processing basics.",
  },
  {
    title: "Industry-Ready Capstone Project",
    description:
      "Capstone Project,End-to-end DS project, Data cleaning to deployment, Model building, Presentation & documentation, Real industry dataset",
  },
  {
    title: "Portfolio Development & Career Launchpad",
    description:
      "Career Preparation,Resume for data roles, GitHub portfolio setup, DS interview prep, Mock interviews, Career roadmap guidance",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
